import { render, staticRenderFns } from "./v-admin-gallery.vue?vue&type=template&id=9ca74a96&"
import script from "./v-admin-gallery.vue?vue&type=script&lang=js&"
export * from "./v-admin-gallery.vue?vue&type=script&lang=js&"
import style0 from "./v-admin-gallery.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports